<template>
    <div class="container-wrap" v-loading="loading">
        <div class="graph-content" ref='graph'>
        </div>
        <!--    <page-device class="page-container" @change="changeSize"-->
        <!--                 @jump="jumpList"-->
        <!--                 :value="pageValue"-->
        <!--                 v-if="!value.haveNoPage"></page-device>-->
    </div>
</template>

<script>
// import {
//   PdSDKDcGraph
// } from '@plantdata/sdk/src/sdk/netchart/graph/dcgraph'
// import config from '@/common/config'
import * as _ from 'lodash'
import PageDevice from './pageDevice'
import {skdUrl} from '@/common/js/http/pdBase'
import {getToken} from 'common/js/http/pdAxios'

export default {
  name: 'normalGraph',
  components: {PageDevice},
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isLayout: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isCenter: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isUpdateLayout: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    hasLegend: {
      type: Boolean,
      default: false
    },
    isRollZommNum: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFirstCreate: true,
      loading: false,
      graph: null,
      pageValue: {
        pageCount: this.value.pageCount,
        page: this.value.page,
        size: this.value.size
      },
      settings: {
        ajaxSettings: {
          baseUrl: config.baseUrl + '/',
          // baseUrl: 'http://192.168.4.31/plantdata-sdk/api/sdk/',
          headers: {
            // APK: '37df4b42bf6442ae8dd263c731dccb6b'
          },
          queryData: {
            p: 'spa_pc_graph'
          }
        },
        schemaSettings: {
          ajaxSettings: {
            // url: 'http://192.168.4.31/plantdata-sdk/api/sdk/app/schema',
            url: skdUrl + '/ensearch/schema',
            type: 'POST',
            data: {}
          }
        },
        showLinkInfoOnClick: true,
        'attValueRule': {
          'enable': false,
          'settings': {
            'box': {
              'isOpen': false
            }
          }
        },
        contextmenu: {
          enable: false,
          settings: {
            menu: {
              'jump': {
                'enable': true,
                'settings': {
                  'children': [
                    {
                      'type': 'graph'
                    },
                    {
                      'type': 'path'
                    },
                    {
                      'type': 'relation'
                    },
                    {
                      'type': 'timing'
                    },
                    {
                      'type': 'explore'
                    }
                  ]
                }
              },
              'business-rule': {
                'enable': false
              }
            }
          }
        },
        infoboxSettings: {
          settings: {
            ajaxSettings: {
              formData: {
                isRelationAtts: false
              }
            }
          }
        },
        // kgName: 'plantdata_bj73pdk7_graph_17332e734da',
        kgName: '',
        netChartSettings: {
          rightPanel: {
            mode: 'fixed',
            active: false
          },
          main: {
            layout: this.value.layout || 'static',
            events: {
              onClick: (event, arg) => {
                this.$emit('changeGraph', event, arg)
              },
              onDoubleClick: (event, arg) => {
                this.$emit('doubleClick', arg.clickItem)
              }
            }
          }
        },
        nodeLegend: {
          enable: this.hasLegend
        },
        linkLegend: {
          settings: {
            color: [
              '#7bc0e1',
              '#9ec683',
              '#fde14d',
              '#ab89f4',
              '#FAC9B8',
              '#dca8c6',
              '#596690',
              '#eaad84',
              '#abe8bf',
              '#7979fc',
              '#FF6F5E',
              '#FFAF5E',
              '#D4B311',
              '#B4D411',
              '#73D411',
              '#11D4B3',
              '#11B3D4',
              '#1152D4',
              '#9311D4'
            ]
          }
        },
        pluginsSettings: {
          settings: {
            size: 'sm'
          }
        },
        promptSettings: {
          ajaxSettings: {
            queryData: {
              isInherit: true,
              openExportDate: true
            }
          }
        },
        showAllSchemaOptions: true,
        timeChart: {
          settings: {
            settings: {
              color: [
                '#5677fc'
              ],
              dataZoom: [
                {
                  fillerColor: 'rgba(57, 141, 238, .3)'
                }
              ]
            },
            dialogSettings: {
              defaultTimeFilterSettings: {
                1: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: false,
                  noTimeNodes: true
                },
                2: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: true
                }
              },
              defaultTimeFilterType: '2',
              rule: {
                1: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                2: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                }
              }
            }
          }
        },
        snapshot: {
          enable: false
        },
        selector: '.graph-content',
        loaderSettings: {
          ajaxSettings: {
            formData: {
              hyponymyDistance: 0
            }
          }
        },
        page: {
          enable: false
        },
        toolbar: {
          enable: false
        },
        changeLayout: {
          enable: this.isUpdateLayout,
          setting: {
            layout: this.value.layout || 'static'
          },
          settings: {
            sankey: false
          }
        },
        find: {
          enable: false
        },
        history: {
          enable: false
        },
        wordCloudView: {
          enable: false
        },
        relativeFiles: {
          enable: false
        },
        visConfigure: {
          enable: false
        },
        filter: {
          enable: true,
          settings: {
            editItemSettings: [
              {
                key: 'isRelationMerge',
                label: '关系展示合并',
                value: 'true',
                options: [
                  {
                    label: '合并',
                    value: 'true'
                  },
                  {
                    label: '不合并',
                    value: 'false'
                  }
                ]
              },
              {
                key: 'hyponymyDistance',
                disabled: true
              },
              {
                key: 'distance',
                options: [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6
                ],
                value: 6
              },
              {
                key: 'allowTypes',
                index: 1
              },
              {
                key: 'allowAtts',
                index: 1
              },
              {
                key: 'distance-expend',
                index: 2
              }
            ]
          }
        },
        prompt: {
          enable: false,
          settings: {
            side: 'left',
            promptSettings: {
              autocompleteSettings: {
                keyword: true
              }
            }
          }
        },
        infobox: {
          enable: false,
          settings: {
            active: true
          }
        },
        resetLayout: {
          enable: false
        },
        wordCloud: {
          enable: false
        },
        advancedPrompt: {
          enable: false
        },
        tagView: {
          enable: false
        },
        zoomSlider: {
          enable: this.isRollZommNum
        }
      }
    }
  },
  watch: {
    'value': {
      handler (to, from) {
        if (!this.graph) {
          this.init(() => {
            this.updateGraph()
          })
        } else {
          this.updateGraph()
        }
      },
      deep: true
    }
  },
  methods: {
    init (fun) {
      !window.allToken && getToken()
      this.settings.ajaxSettings.headers['api-token'] = window.allToken
      if (window.PdSDKDcGraph) {
        this.settings.changeLayout.setting.layout = this.value.layout
        if (this.isLayout) {
          this.settings.changeLayout.enable = true
          this.settings.resetLayout.enable = true
        }
        this.graph = new PdSDKDcGraph(this.settings)
        this.graph.on('inited', () => {
          if (this.isCenter) {
            this.draw()
          }
          if (this.isUpdateLayout) {
            this.updateLayout()
          }
          fun && fun()
        })
      } else {
        window.newGraph = setTimeout(() => {
          if (window.newGraph !== 15) {
            this.init(fun)
          }
        }, 1000)
      }
    },
    updateGraph () {
      if (this.value.graph) {
        let focus = {}
        if (this.value.graph.entityList && this.value.graph.entityList.length) {
          focus = this.value.graph.entityList[0]
        }
        const graph = _.cloneDeep(this.value.graph)
        this.graph.netChart.addData(graph, focus)
        // this.graph.load({id: focus.id})
      }
    },
    changeSize (val) { // 切换每页的个数
    },
    jumpList (val) { // 翻页
    },
    draw () {
      this.graph.netChart.on('beforedraw', () => {
        setTimeout(() => {
          if (this.isFirstCreate && this.isRollZommNum) {
            const zoom = 0.7
            this.graph.zoomSlider.zoomSlider.settings.change(zoom)
            this.isFirstCreate = false
          } else if (!this.isRollZommNum) {
            this.graph.netChart.fitPanel()
          }
        }, 1000)
      })
    },
    updateLayout () {
      this.graph.netChart.on('beforedraw', () => {
        setTimeout(() => {
          this.graph.changeLayout.updateLayout(this.value.layout || 'static')
        }, 1000)
      })
    },
    handleUpdataLayout () {
      setTimeout(() => {
        this.graph.netChart.resetLayout()
      })
    },
    watchGraph (num) {
      clearTimeout(window.watchGraph)
      this.loading = false
      if (this.graph && this.graph.netChart) {
        setTimeout(() => {
          this.updateGraph()
          clearTimeout(window.watchGraph)
        }, 1500)
      } else if (this.graph && !this.graph.netChart) {
        setTimeout(() => {
          this.updateGraph()
          clearTimeout(window.watchGraph)
        }, 3500)
      } else {
        num = num || 0
        if (num > 20) {
          return
        }
        window.watchGraph = setTimeout(() => {
          num = num + 1
          this.watchGraph(num)
        }, 500)
      }
    }
  },
  destroyed () {
    clearTimeout(window.newGraph)
    clearTimeout(window.watchGraph)
  }
}
</script>

<style lang="scss" scoped>
    /*@import "../../../../../node_modules/@plantdata/sdk/src/sdk/index";*/
    /*@import "../../../../../node_modules/@zc/netchart/netchart";*/

    /deep/ .graph-content {
        width: 100%;
        height: 100%;

        .pd-panel-right {
            display: none;
        }
    }

    /deep/ .plantdata-ns .pd-panel-overlay:not(:empty).pd-panel-right ~ .pd-panel-float-top {
        margin-right: 0;
    }

    /deep/ .plantdata-ns .pdvis-edit-item-select {
        background: #ffffff;
    }

    /deep/ .plantdata-ns .pdvis-change-layout-container select {
        height: 30px;
    }

    /deep/ .pd-panel-float .pd-panel-float-item {
        font-size: 14px !important;
        border-color: rgb(220, 223, 230) !important;
    }

    /deep/ .pd-panel-float .pdvis-float-item-head {
        border-color: rgb(220, 223, 230) !important;
    }

    /deep/ .pdvis-reset-layout-container .pdvis-float-item-head .pd-panel-tooltip {
        height: 30px;
        line-height: 30px;
    }

    /deep/ .plantdata-ns .pd-panel-main {
        > .pd-panel-tabs {
            border: none !important;
        }

        .pd-panel-pages {
            .active {
                border: none !important;
            }
        }
    }

</style>
<style lang="scss" scoped>
    .active {
        border: none;
    }

    .container-wrap {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .page-container {
        position: absolute;
        top: 0;
        right: 178px;
        z-index: 99;
    }

    .graph-content {
        background: #ffffff !important;

        /deep/ .pd-panel-float {
            margin: 0;
        }

        /deep/ .pdvis-change-layout-container, /deep/ .pdvis-reset-layout-container .pdvis-float-item-head {
            box-shadow: none;
            border: 1px solid rgba(0, 0, 0, 0.1);
            padding: 0;
            font-size: 12px;
        }

        /deep/ .pdvis-reset-layout-container {
            .pdvis-float-item-head {
                height: 32px;
                width: 32px;
                display: flex;
                justify-content: center;
                align-items: center;

                .pd-panel-icon {
                    width: 26px;
                    height: 26px;
                    margin-left: 5px;
                    padding: 1px 0 !important;
                }

                .pd-panel-tooltip {
                    font-size: 12px;
                    line-height: 32px;
                    height: 32px;
                    display: none;
                }
            }
        }
    }
</style>
